import { translate } from '../i18n'
import { InputValidator } from './InputValidator'

export class RequiredValidator implements InputValidator {
    type: string

    constructor(type: string) {
        this.type = type
    }

    isValid = (value: unknown) => {
        if (value === undefined && value === null) {
            return false
        }

        switch (this.type) {
            case 'number':
                return !isNaN(parseFloat(`${value}`))
            default:
                return `${value ?? ''}`.trim().length > 0
        }
    }
    getMessage = () => translate('validations.required') as string
}

export const TEXT_REQUIRED_VALIDATOR = new RequiredValidator('text')

export const NUMBER_REQUIRED_VALIDATOR = new RequiredValidator('number')
